import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import cropStorageImage from 'rebook/apps/utils/urls/cropStorageImage';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import truncateChars from 'rebook/apps/utils/text/truncateChars';
import {
  BOOKS_BOOK_REVIEW_SET_DATA,
  BOOKS_BOOK_REVIEW_RESET_DATA,
} from 'rebook/apps/books/constants';
import { Review } from 'rebook/apps/books/models';


export function fetchInitialData(match, location = {}, isOldVersion = false) {
  return async(dispatch, getState) => {
    const currentState = getState().bookReview;
    let newState = {};
    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    if (currentState.review) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.review || isOldVersion) {
      await dispatch(fetchReview(match, isOldVersion));
    }
  };
}

export function fetchReview(match, isOldVersion = false) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { reviewId } = match.params;
    const url = `/api/book-reviews/${reviewId}/?html=1`;
    let options = {
      apiVersion: 4,
    };

    if (isOldVersion) {
      options.apiVersion = 2;
    }

    if (get(ssr, 'headers', null)) {
      options.headers = ssr.headers;
    }

    return await fetchQuery(url, options)
      .then(
        ({ data }) => {
          dispatch(setData({ review: data }));
        }
      )
      .catch(
        ({ resp, data, error }) => {
          if (resp && get(resp, 'status', null) === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to load review due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load review due to server error');
          }
        }
      );
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { bookReview } = getState();
    const { review } = bookReview;
    const theReview = review && new Review(review);
    const cover200x300 = cropStorageImage(review.book.default_cover, 200, 300);
    const desktopUrl = `https://${BASE_HOST}${theReview.getUrl()}`;

    const title = `Рецензия ${review.username} на книгу ` +
        `${review.book.main_author
          ? `— ${review.book.main_author.genitive_full_name || review.book.main_author.cover_name}`
          : '' } ` +
        `«${review.book.name}» — MyBook`;
    const description = truncateChars(review.comment_plain ? review.comment_plain : review.comment, 300);
    const ogTitle = title;
    const ogDescription = description;
    const ogTags = [
      { name: 'type', value: 'books.book' },
      { name: 'image', value: cover200x300 },
      { name: 'title', value: ogTitle },
      { name: 'description', value: ogDescription },
      { name: 'url', value: desktopUrl },
    ];
    const ogTwitterTags = [
      { name: 'title', value: ogTitle },
      { name: 'description', value: ogDescription },
      { name: 'image', value: cover200x300 },
    ];
    let ogBookTags = [
      { name: 'rating:value', value: review.book_rating ? review.book_rating : 0 },
      { name: 'rating:scale', value: 5 },
    ];
    if (review.book.ean) {
      ogBookTags.push({
        name: 'isbn',
        value: review.book.ean,
      });
    }
    if (review.book.main_author) {
      ogBookTags.push({
        name: 'author',
        value: `https://${BASE_HOST}${review.book.main_author.absolute_url}`,
      });
    }
    dispatch(SeoActions.setData({
      imageSrc: cover200x300,
      canonicalUrl: desktopUrl,
      title,
      description,
      ogTags,
      ogBookTags,
      ogTwitterTags,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { review } = payload;
    dispatch({
      type: BOOKS_BOOK_REVIEW_SET_DATA,
      payload,
    });
    if (review && get(review, 'book', false)) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: BOOKS_BOOK_REVIEW_RESET_DATA,
    });
  };
}
